// https://codepen.io/p8952/pen/BpvvPW
export default function drawOscilloscope(mediaStream, canvasElement) {
  // const canvasElement = document.getElementById(element);
  const canvasContext = canvasElement.getContext('2d');

  const audioContext = new AudioContext();
  const analyserNode = audioContext.createAnalyser();
  const bufferLength = analyserNode.frequencyBinCount;
  const dataArray    = new Uint8Array(bufferLength);

  const mediaStreamSource = audioContext.createMediaStreamSource(mediaStream);
  mediaStreamSource.connect(analyserNode);

  function draw() {
    requestAnimationFrame(draw);
    analyserNode.getByteTimeDomainData(dataArray);

    canvasContext.clearRect(0, 0, canvasElement.width, canvasElement.height);
    canvasContext.lineWidth = 1;
    canvasContext.strokeStyle = '#000000';
    canvasContext.beginPath();
    canvasContext.moveTo(0, canvasElement.height / 2);

    let x = 0;
    const sliceWidth = canvasElement.width / bufferLength;
    for (let i = 0; i < bufferLength; i += 1) {
      const v = dataArray[i] / 128;
      const y = (canvasElement.height / 2) * v;
      canvasContext.lineTo(x, y);
      x += sliceWidth;
    }

    canvasContext.lineTo(canvasElement.width, canvasElement.height / 2);
    canvasContext.stroke();
  }

  draw();
}
